import { makeStyles } from '@material-ui/core/styles';
import { em, rem, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(theme => ({
  dialogPaper: {
    minHeight: '95.96vh',
    maxHeight: '95.96vh',
    minWidth: '97.51vw',
    maxWidth: '97.51vw',
    borderRadius: 'unset',
    backgroundColor: themeColor.lightBackground,
  },
  closeButton: {
    width: '100%',
    borderRadius: '2px',
    fontSize: vh(2.34),
    letterSpacing: '0.5px',
    boxShadow: `0 1px 1px 0 ${themeColor.almosttransparentblack}`,
    '&:hover': {
      boxShadow: 'none',
    },
  },
  resultSummary: {
    '& span': {
      fontSize: vh(2.08),
      color: theme.palette.info.main,
      marginLeft: '1vw',
      letterSpacing: '0.53px',
      fontWeight: 500,
    },
  },
  resultSummaryTransaction: {
    height: 20,
  },
  resultSummaryProducts: {
    marginTop: '0vh',
    marginBottom: '1.0416666666667vh',
    marginLeft: '0.5vw',
  },
  icon: {
    width: '3.9vh',
    height: '3.9vh',
  },
  searchResults: {
    marginTop: '1.17vh',
    height: '72vh',
  },
  searchResultsProduct: {
    height: '92vh',
  },
  trainingModeBackground: {
    height: vh(72),
    backgroundColor: themeColor.trainingBackground,
  },
  searchContainer: {
    height: 'fit-content',
    boxSizing: 'border-box',
    boxShadow: '0px -5px 20px rgba(48, 66, 75, 0.4)',
  },
  searchTitleBar: {
    color: themeColor.infoMain,
    letterSpacing: 0.44,
    lineHeight: 1.25,
    fontSize: rem(2.08),
    borderTop: `0.5vw solid ${theme.palette.secondary.main}`,
  },
  searchTitleHeader: {
    color: themeColor.modalTitle,
  },
  searchTitleHeaderLabel: {
    fontSize: rem(2.5),
    '@media (max-width: 1600px)': {
      fontSize: rem(2),
    },
    '@media (max-width: 1366px)': {
      fontSize: rem(1.7),
    },
    '@media (width: 1366px) and (height: 768px)': {
      fontSize: rem(1.7),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(2.3),
    },
    '@media (max-width: 1024px)': {
      fontSize: rem(1.4),
    },
    '@media  (width: 1024px) and (height: 768px)': {
      fontSize: rem(1.5),
    },
    fontWeight: 500,
    paddingTop: '0.651vh',
  },
  searchTitleContainer: {
    height: '8.8vh',
    marginLeft: '1vw',
  },
  main: {
    fontSize: em(16),
    width: '100.51vw',
    height: '95.96vh',
    outline: 0,
  },
  modal: {
    marginTop: '10.01vh',
  },
  background: {
    backgroundColor: themeColor.lightBackground,
  },
  searchContainerProducts: {
    padding: '1.2vh',
    paddingRight: '1.375vw',
    '@media  (width: 1024px) and (height: 576px)': {
      padding: '0.6vh',
      paddingRight: '1.1vw',
    },
  },
  searchTransactions: {
    paddingRight: '1.61vw',
  },
}));
